import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LinkContainer } from 'react-router-bootstrap';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import { actionCreators } from '../../store/modules/User';

class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  handleFacebookCallback = (resposne) => {
    const { requestLogin } = this.props;

    if (resposne.userID && resposne.accessToken) {
      requestLogin(resposne.userID, resposne.accessToken, 'facebook');
    }
  };

  handleGoogleCallback = (resposne) => {
    const { requestLogin } = this.props;

    if (resposne.googleId && resposne.accessToken) {
      requestLogin(resposne.googleId, resposne.accessToken, 'google');
    }
  };

  handleSave(values) {
    const { requestLogin } = this.props;

    if (values.email && values.password) {
      requestLogin(values.email, values.password, null);
    }
  }

  render() {
    return (
      <Formik onSubmit={values => this.handleSave(values)}
        ref={this.form}
        enableReinitialize
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .min(6)
            .max(100)
            .required(),
          email: Yup.string()
            .email()
            .min(5)
            .max(254)
            .required(),
        })}
        initialValues={{
          email: '',
          password: '',
        }}
        render={({ values, errors }) => (
          <Form>
            <div id="dataForm">
              <div className="row m-b-sm">
                <div className="col-sm-12">
                  <span className="page-title no-image">Ienākt</span>
                </div>
              </div>
              <div className="row p-l-md">
                <div className="col-md-12">
                  <div className="panel panel-default">
                    <div className="panel-heading" />
                    <div className="panel-body" id="scroller">
                      <div className="col-md-3" />
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="email" className="control-label font-bold">
                                Epasts
                                <Field id="email"
                                  name="email"
                                  type="email"
                                  autoFocus
                                  autoComplete="off"
                                  className={errors.email ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="password" className="control-label font-bold">
                                Parole
                                <Field id="password"
                                  value={values.password || ''}
                                  name="password"
                                  type="password"
                                  autoComplete="off"
                                  className={errors.password ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xs-12">
                            <button type="submit" className="gaas-tile-btn">
                              Ienākt
                            </button>
                            <LinkContainer to="/password" className="forgot-password">
                              <span>Aizmirsu Paroli</span>
                            </LinkContainer>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-xs-6 facebook-login">
                            <FacebookLogin appId="498455930892183"
                              textButton="Ienākt ar Facebook kontu"
                              callback={response => this.handleFacebookCallback(response)} />
                          </div>
                          <div className="col-xs-6 google-login">
                            <GoogleLogin clientId="919517785115-a3914c9hvghto8jlvcsmvl8uuvm78pjs.apps.googleusercontent.com"
                              buttonText="Ienākt ar Google kontu"
                              onSuccess={response => this.handleGoogleCallback(response)} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )} />
    );
  }
}

UserLogin.propTypes = {
  requestLogin: PropTypes.func.isRequired,
};

export default connect(
  null,
  dispatch => bindActionCreators(actionCreators, dispatch),
)(UserLogin);



// WEBPACK FOOTER //
// ./src/components/user/Login.jsx